import React from 'react';
import PropTypes from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../.internal/BaseComponent';

import LoadingSpinner from '../.deprecated/loading_spinner/LoadingSpinner';

import './Card.scss';

export default class Card extends BaseComponent {
  render() {
    const { loading, id, className, style, children } = this.props;

    const classNames = ClassNames(['Card', className]);

    return (
      <div id={id} style={style} className={classNames}>
        {loading ? <LoadingSpinner color="primary" /> : children}
      </div>
    );
  }
}

Card.propTypes = {
  loading: PropTypes.bool,
  style: PropTypes.shape({}),
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

Card.defaultProps = {
  loading: false,
  style: {},
  id: undefined,
  className: undefined,
  children: undefined
};
